import { memo } from 'react';
import { SubscribeLoader } from './SubscribeLoader';

export default memo(SubscribeLoader);
